<template>
  <div class="product-detail">
    <!-- 加载状态 -->
    <div v-if="!productDetail" class="loading">
      <p>加载中...</p>
    </div>
    <div v-else>
      <div class="title">
        <p>{{ productDetail.projectTitle }}</p>
      </div>
      <!-- 可左右滑动的选择卡标题栏（隐藏滚动条） -->
      <div class="tabs-container">
        <div class="tabs-wrapper" ref="tabsWrapper">
          <div
            v-for="(group, index) in productDetail.images"
            :key="index"
            class="tab-item"
            :class="{ active: activeTabIndex === index }"
            @click="selectTab(index)"
          >
            {{ group.title || `图片组 ${index + 1}` }}
          </div>
        </div>
      </div>

      <!-- 当前选中组的图片展示 -->
      <div class="current-group">
        <div class="images-wrapper">
          <img
            v-for="(imgUrl, imgIndex) in currentImages"
            :key="imgIndex"
            :src="imgUrl"
            :alt="currentGroupTitle"
            class="detail-img"
          />
        </div>
        <!-- 没有图片时的提示 -->
        <div v-if="!currentImages.length" class="no-img-tip">
          <p>暂无图片</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectImages } from "@/api/product";

export default {
  data() {
    return {
      productDetail: null, // 接口返回数据 { projectTitle, images }
      activeTabIndex: 0, // 当前选中的选择卡索引
    };
  },
  computed: {
    // 当前选中的图片组
    currentGroup() {
      if (!this.productDetail || !this.productDetail.images) return null;
      return this.productDetail.images[this.activeTabIndex];
    },
    // 当前组的标题
    currentGroupTitle() {
      return this.currentGroup ? this.currentGroup.title : "";
    },
    // 当前组的图片列表
    currentImages() {
      return this.currentGroup ? this.currentGroup.images : [];
    },
  },
  async created() {
    const productId = this.$route.params.id; // 从路由获取项目id
    try {
      const res = await getProjectImages(productId);
      console.log("接口返回数据：", res);
      if (res && res.status === 200 && res.data) {
        this.productDetail = res.data;
        // 如果有图片组数据，默认选中第一个
        if (this.productDetail.images && this.productDetail.images.length) {
          this.activeTabIndex = 0;
        } else {
          this.productDetail.images = [];
        }
      } else {
        this.productDetail = { projectTitle: "", images: [] };
        alert(res && res.msg ? res.msg : "商品详情加载失败");
      }
    } catch (error) {
      console.error("请求商品详情失败", error);
      this.productDetail = { projectTitle: "", images: [] };
      alert("请求失败，请稍后重试");
    }

 this.$nextTick(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' // 使用 'instant' 立即滚动，或 'smooth' 平滑滚动
    });
  });

  },
  methods: {
    // 切换选择卡
    selectTab(index) {
      this.activeTabIndex = index;
      // 滚动选中的tab到可视区域中央
      this.scrollTabIntoView(index);
    },
    // 将选中的tab滚动到可视区域（平滑效果）
    scrollTabIntoView(index) {
      this.$nextTick(() => {
        const wrapper = this.$refs.tabsWrapper;
        if (!wrapper) return;
        const activeTab = wrapper.children[index];
        if (activeTab) {
          activeTab.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      });
    },
  },
  mounted() {
  // 确保页面从顶部开始
  window.scrollTo(0, 0);
  this.initScrollListener();
},
};
</script>

<style scoped>



.product-detail {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.loading {
  text-align: center;
  padding: 10vw 0;
  font-size: 3.5vw;
  color: #999;
}
.title p{
  font: 700 5vw "宋体";
  color: #393939;
  text-align: center;
  line-height: 14vw;
  background-color: #fff;

}
/* 选择卡容器 - 移动端左右滑动，隐藏滚动条 */
.tabs-container {
  width: 100%;
  padding-bottom: 1.5vw;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
  border-bottom: 0.2vw solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 10;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* 禁止拖拽时选中文本 */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.tabs-container::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.tabs-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 0;
  padding: 0;
  min-width: min-content;
}

.tab-item {
  flex: 0 0 auto;
  padding: 3vw 4vw;
  font-size: 3.8vw;
  font-weight: 500;
  color: #666;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
}

.tab-item.active {
  color: #ff6b6b;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 4vw;
  right: 4vw;
  height: 0.5vw;
  background-color: #ff6b6b;
  border-radius: 0.25vw;
}

/* 当前组展示区域 */
.current-group {
  padding: 4vw 0;
  background-color: #f5f5f5;
}

/* 图片容器 - 图片宽度95% */
.images-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4vw;
  width: 100%;
}

.detail-img {
  width: 95%;
  max-width: 95%;
  height: auto;
  border-radius: 2vw;
  background-color: #fff;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.08);
}

/* 无图片提示 */
.no-img-tip {
  text-align: center;
  padding: 15vw 5vw;
  color: #999;
  font-size: 3.5vw;
  background-color: #fff;
  margin: 4vw;
  border-radius: 2vw;
}
@media (min-width: 1100px) {
  .title p{
  font: 700 5vw "宋体";
  line-height: 140px;
  font-size: 90px;
  }
  .product-detail {
    width: 2400px;
    margin: 0 auto;
  }
.tab-item {
  padding: 40px 40px;
  font-size: 50px;
}
.tab-item.active::after {
  left: 40px;
  right: 40px;
  height: 9px;
  border-radius: 10px;
}
.tabs-container {
  padding-bottom: 20px;
}
}
</style>
